export type LessonCategory = "primeiros-passos" | "ferramentas" | "analise" | "suporte";

export type Lesson = {
  id: string;
  number: number;
  category: LessonCategory;
  title: string;
  description: string;
  duration?: string;
  youtubeId: string | null;
};

export const CATEGORY_META: Record<
  LessonCategory,
  { label: string; subtitle: string }
> = {
  "primeiros-passos": {
    label: "Primeiros passos",
    subtitle: "Comece por aqui — o essencial em poucos minutos.",
  },
  ferramentas: {
    label: "Ferramentas",
    subtitle: "As ferramentas do dia a dia do CDP.",
  },
  analise: {
    label: "Análise",
    subtitle: "Como ler os relatórios da IA e aplicar os insights.",
  },
  suporte: {
    label: "Suporte",
    subtitle: "Fale com o time e ajude a moldar o produto.",
  },
};

export const lessons: Lesson[] = [
  {
    id: "introducao",
    number: 1,
    category: "primeiros-passos",
    title: "Bem-vindo ao CDP",
    description:
      "Visão geral do app em 1 minuto. O que cada parte faz e por onde começar.",
    duration: "1:35",
    youtubeId: "6VdAqfMkm4s",
  },
  {
    id: "onboarding",
    number: 2,
    category: "primeiros-passos",
    title: "Configure seu perfil",
    description:
      "Preencha identidade, posicionamento, voz e procedimentos. A IA usa isso para calibrar tudo no seu estilo.",
    duration: "5:26",
    youtubeId: "DFrWLB8bnHs",
  },
  {
    id: "dashboard",
    number: 3,
    category: "primeiros-passos",
    title: "Tela inicial",
    description:
      "Visão geral da home: progresso de pontos, atalhos e ações rápidas do dia a dia.",
    duration: "1:29",
    youtubeId: "vl332MOE--Q",
  },
  {
    id: "configurar-ia",
    number: 4,
    category: "primeiros-passos",
    title: "Configurar a IA (chaves de API)",
    description:
      "Passo a passo de como criar e cadastrar sua chave da OpenAI para usar os recursos de IA.",
    youtubeId: "oVt5YswGKXg",
  },
  {
    id: "uso-custos",
    number: 5,
    category: "ferramentas",
    title: "Uso & Custos",
    description:
      "Acompanhe créditos consumidos, gráfico por dia e filtre por período antes de fechar o mês.",
    duration: "1:28",
    youtubeId: "qHurVcsi_Ww",
  },
  {
    id: "roteiros-conteudo",
    number: 6,
    category: "ferramentas",
    title: "Roteiros de conteúdo",
    description:
      "Gere copy de Reels, Stories e anúncios alinhada ao seu posicionamento, com IA.",
    duration: "2:50",
    youtubeId: "f3929W81R3U",
  },
  {
    id: "perfil-cliente",
    number: 7,
    category: "ferramentas",
    title: "Perfil do Cliente",
    description:
      "Decodifique a personalidade do lead ou cliente para conduzir a venda do jeito certo.",
    duration: "1:51",
    youtubeId: "5qMCat0ZHqQ",
  },
  {
    id: "simulador",
    number: 8,
    category: "ferramentas",
    title: "Simulador de Atendimento",
    description:
      "Treine consultas de venda com pacientes ou leads simulados antes da consulta real.",
    duration: "2:15",
    youtubeId: "wgIVPCVpkhk",
  },
  {
    id: "analise-criativo",
    number: 9,
    category: "analise",
    title: "Análise de Criativo",
    description:
      "Suba um Reel, anúncio ou post e veja o que a IA avalia e como melhorar.",
    duration: "2:26",
    youtubeId: "UAtJZ7QKs-U",
  },
  {
    id: "analise-consulta",
    number: 10,
    category: "analise",
    title: "Analisar Consulta",
    description:
      "Transforme o áudio de uma consulta de vendas em diagnóstico acionável.",
    duration: "6:28",
    youtubeId: "yCqLpPuAdnc",
  },
  {
    id: "raiox-funil",
    number: 11,
    category: "analise",
    title: "Raio-X do Funil",
    description:
      "Diagnóstico das etapas do funil: sonar, planejamento, métricas comerciais e CPA.",
    duration: "0:35",
    youtubeId: "aONr6IteLj8",
  },
  {
    id: "feedbacks",
    number: 12,
    category: "suporte",
    title: "Feedbacks e dúvidas",
    description:
      "Como reportar bug, sugerir melhoria ou enviar feedback direto para a equipe.",
    duration: "2:22",
    youtubeId: "23nTNx9SJ5Y",
  },
];

export const CATEGORY_ORDER: LessonCategory[] = [
  "primeiros-passos",
  "ferramentas",
  "analise",
  "suporte",
];
